import styled from '@emotion/styled';
import React from 'react';

import { SvgSearch } from '../icon/available-icons/search';
import TextInput from '../text-input/text-input';
import { u } from '../../utilities';

const SearchBarContainer = styled.div`
  padding: ${u(1.5)} ${u(1.5)} 0;
  margin-bottom: ${u(1.5)};
  position: sticky;
  top: 0;
`;

const SearchBar = ({
  ariaLabel,
  placeholder,
  value,
  onChange,
  getInputProps,
}: {
  ariaLabel: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  getInputProps?: any;
}) => {
  const inputProps = getInputProps
    ? getInputProps({
        placeholder,
        value,
        type: 'text',
      })
    : { placeholder, value, type: 'text' as const };

  // We need to support calling both Downshift and our custom onChange handler for backend search
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Call Downshift's onChange if it exists (from getInputProps)
    if (inputProps.onChange) {
      inputProps.onChange(e);
    }
    // Always call our custom onChange
    onChange(e);
  };

  return (
    <SearchBarContainer>
      <TextInput
        aria-label={ariaLabel}
        icon={<SvgSearch />}
        {...inputProps}
        onChange={handleChange}
      />
    </SearchBarContainer>
  );
};

export default SearchBar;
